/**
 * Who loses when you win.
 *
 * `RIVALRY[a][b]` is what happens to `b` for every point you gain with `a`.
 * Negative is a rival, positive is an ally, absent is indifference. So a +10
 * with Banquets is -6 with the Kitchen, -3.5 with Housekeeping, and a polite
 * +1.5 with Valet.
 *
 * Deliberately **asymmetric**, because departments are. The Kitchen takes a
 * Banquets win harder (-0.7) than Banquets takes a Kitchen win (-0.6): the
 * kitchen believes banquets exists to ruin their food, and banquets believes
 * the kitchen is a weather system. That asymmetry is the entire reason this is
 * a matrix and not a list of feuding pairs.
 *
 * Management is the trap. Every point you earn with Management costs you with
 * all six departments that actually work the floor, and Management gives back
 * very little — being liked by the office is not a strategy, it is a tell.
 *
 * Edit freely. Nothing in the code knows the name of a single department.
 */

export const RIVALRY = {
  banquets: {
    // The war. Late food, wrong counts, and a hundred years of it.
    kitchen: -0.6,
    // Linen, carts, and whose job the ballroom floor is.
    housekeeping: -0.35,
    // Valet parks your event. Banquets tips them out.
    valet: 0.15,
    frontdesk: -0.1,
    management: 0.1,
  },
  kitchen: {
    banquets: -0.7,
    housekeeping: -0.15,
    frontdesk: -0.05,
    // Walk-in compressors, and how long Engineering takes to look at one.
    engineering: -0.2,
    management: 0.05,
  },
  housekeeping: {
    banquets: -0.3,
    kitchen: -0.1,
    // Rooms not ready, and who told the guest they would be.
    frontdesk: -0.55,
    engineering: 0.2,
  },
  valet: {
    banquets: 0.1,
    // The drive. Who owns it, who blocks it, who takes the tip.
    frontdesk: -0.5,
    engineering: -0.1,
    management: 0.05,
  },
  frontdesk: {
    banquets: -0.15,
    housekeeping: -0.5,
    valet: -0.45,
    engineering: -0.15,
    management: 0.2,
  },
  engineering: {
    kitchen: -0.25,
    housekeeping: 0.2,
    valet: -0.05,
    frontdesk: -0.1,
    // Budget. Always budget.
    management: -0.3,
  },
  management: {
    banquets: -0.4,
    kitchen: -0.4,
    housekeeping: -0.35,
    valet: -0.3,
    frontdesk: -0.2,
    engineering: -0.35,
  },
};

export default RIVALRY;
